import React, { useEffect } from "react";
import Header from "../../components/header/Header";
import { Box } from "@mui/material";
import LabourAndPackingCard from "../../components/labourAndPackingCard/LabourAndPackingCard";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setTheme } from "../../redux/reducers/themeSlice";
import { getCarrierByBusinessName } from "../../redux/action/carrier";
import { unwrapResult } from "@reduxjs/toolkit";
import JunkRemovalCard from "../../components/junkRemovalCard/JunkRemovalCard";

const JunkRemoval = () => {
  const dispatch = useDispatch();
  const isValidColor = (color: string): boolean => {
    const colorRegex =
      /^#([0-9A-Fa-f]{3}){1,2}$|^(rgb|rgba|hsl|hsla)\([^\)]*\)$/;
    return colorRegex.test(color);
  };
  const { businessName } = useParams();
  const CarrierBusinessName = localStorage.getItem("businessName");
  useEffect(() => {
    if (CarrierBusinessName) {
      return;
    } else {
      if (businessName) {
        dispatch<any>(getCarrierByBusinessName(businessName))
          .then(unwrapResult)
          .then((res: any) => {
            localStorage.setItem("businessName", businessName);
            if (res.color_hex && isValidColor(res.color_hex)) {
              dispatch(
                setTheme({
                  primaryColor: res.color_hex,
                  secondaryColor: "#A8E6FF",
                })
              );
            }
          })
          .catch((err: any) => {
            console.error("Failed to fetch carrier data:", err);
          });
      }
    }
  }, [businessName, dispatch]);
  return (
    <div>
      <Box sx={{ width: "100%" }} >
        <Header />
        <JunkRemovalCard />
      </Box>
    </div>
  );
};

export default JunkRemoval;